import { Font } from '@react-pdf/renderer';

// Registers Montserrat with @react-pdf so <Text> can resolve weights 400-700.
// .ttf files live in ui/public/fonts/montserrat/ and are served at /fonts/...
// by both the dev server and CloudFront in production.
//
// Disable hyphenation — Montserrat with @react-pdf's default Knuth-Plass
// hyphenator produces awkward mid-word breaks in our short, list-heavy copy.
let registered = false;

const FONT_SOURCES = [
  { src: '/fonts/montserrat/Montserrat-Regular.ttf',  fontWeight: 400 },
  { src: '/fonts/montserrat/Montserrat-Medium.ttf',   fontWeight: 500 },
  { src: '/fonts/montserrat/Montserrat-MediumItalic.ttf', fontWeight: 500, fontStyle: 'italic' },
  { src: '/fonts/montserrat/Montserrat-SemiBold.ttf', fontWeight: 600 },
  { src: '/fonts/montserrat/Montserrat-Bold.ttf',     fontWeight: 700 },
];

// Everything the renderer fetches over the network at generation time: the
// five fonts plus the logo PageFrame embeds. One dropped request = one failed
// download, so the download button warms these into the HTTP cache on mount.
export const PDF_ASSET_URLS = [
  ...FONT_SOURCES.map(f => f.src),
  '/images/multiply-icon.png',
];

let warmed = false;
export function warmPdfAssets() {
  if (warmed || typeof fetch !== 'function') return;
  warmed = true;
  for (const url of PDF_ASSET_URLS) {
    // Best-effort cache warm; failures here are fine — generation retries.
    fetch(url, { cache: 'force-cache' }).catch(() => { warmed = false; });
  }
}

export function registerFonts() {
  if (registered) return;
  registered = true;

  Font.register({
    family: 'Montserrat',
    fonts: FONT_SOURCES,
  });

  Font.registerHyphenationCallback(word => [word]);
}
